const es = {
  melhous: "MELHOUS",
  "melhous.service": "Servicios",
  "melhous.item_service": "Items de Servicio",
  "melhous.special_services": "Servicios Especiales",
  "melhous.other_services": "Otros Servicios",
  "melhous.gallery_areas": "Galería",
  "melhous.title": "Título",
  "melhous.banner": "Banner",
  "melhous.desc": "Descripción",
  "melhous.address": "Dirección",
  "melhous.url": "URL",
  "melhous.wifi": "WiFi",
  "melhous.wifi_pass": "Contraseña WiFi",
  "melhous.phone": "Teléfono",
  "melhous.reception_phone": "Tel. Recepción",
  "melhous.reception_phone2": "Tel. Recepción 2",
  "melhous.reception_phone3": "Tel. Recepción 3",
  "melhous.breakfast_start": "Inicio Desayuno",
  "melhous.breakfast_end": "Fin Desayuno",
  "melhous.lunch_start": "Inicio Almuerzo",
  "melhous.lunch_end": "Fin Almuerzo",
  "melhous.meal_start": "Inicio Cena",
  "melhous.meal_end": "Fin Cena",
  "melhous.check_in": "Check-In",
  "melhous.check_out": "Check-Out",
  "melhous.title_gallery": "Título Galería",
  "melhous.desc_gallery": "Descripción Galería",
  "melhous.service.title": "Título",
  "melhous.service.icon": "Icono",
  "melhous.service.button": "Botón",
  "melhous.service.description": "Descripción",
  "melhous.item_service.title": "Título",
  "melhous.item_service.description": "Descripción",
  "melhous.item_service.icon": "Icono",
  "melhous.special_services.title": "Título",
  "melhous.special_services.image": "Imagen",
  "melhous.special_services.note": "Nota",
  "melhous.special_services.permitted": "Permitido",
  "melhous.special_services.description": "Descripción",
  "melhous.other_services.title": "Título",
  "melhous.other_services.icon": "Icono",
  "melhous.other_services.description": "Descripción",
  "melhous.gallery_areas.title": "Título",
  "melhous.gallery_areas.image": "Imagen",
  "melhous.gallery_areas.video": "Video",
  "melhous.gallery_areas.desc": "Descripción",
  "crm.customer_service": "PQRS",
  "crm.customer_service.number": "Número",
  "crm.customer_service.state": "Estado",
  "crm.customer_service.party": "Cliente",
  "crm.customer_service.customer": "Cliente",
  "crm.customer_service.address": "Dirección",
  "crm.customer_service.phone": "Teléfono",
  "crm.customer_service.city": "Ciudad",
  "crm.customer_service.case": "Caso",
  "crm.customer_service.media": "Medio",
  "crm.customer_service.description": "Descripción",
  "crm.customer_service.diagnose": "Diagnóstico",
  "crm.customer_service.response": "Respuesta",
  "crm.customer_service.cs_date": "Fecha",
  "crm.customer_service.effective_date": "Fecha Efectiva",
  "crm.customer_service.satisfaction": "Satisfacción",
  "crm.customer_service.efficacy": "Eficacia",
  "crm.customer_service.responsible_employee": "Responsable",
  "crm.customer_service.department": "Departamento",
  "crm.customer_service.notes": "Notas",
  "crm.customer_service.action_plan": "Plan de Acción",
  "crm.customer_service.category_customer": "Categoría",
  "crm.customer_service.draft": "Borrador",
  "crm.customer_service.open": "Abierto",
  "crm.customer_service.close": "Cerrado",
  "melhous.link_melhous": "Link Melhous (dirección de la app, usada en los QR)",
  "melhous.require_table_qr": "Exigir QR de Mesa",
  "melhous.guide_items": "Guía",
  "melhous.messages": "Mensajes",
  "melhous.request_types": "Tipos de Solicitud",
  "melhous.recommendations": "Recomendaciones",
  "melhous.guide_item": "Guía",
  "melhous.guide_item.section": "Sección",
  "melhous.guide_item.title": "Título",
  "melhous.guide_item.description": "Descripción",
  "melhous.guide_item.schedule": "Horario",
  "melhous.guide_item.link": "Enlace",
  "melhous.guide_item.sequence": "Secuencia",
  "melhous.guide_item.hotel": "Hotel",
  "melhous.guide_item.nearby": "Alrededores",
  "melhous.message": "Mensajes",
  "melhous.message.title": "Título",
  "melhous.message.body": "Mensaje",
  "melhous.message.kind": "Tipo",
  "melhous.message.start": "Inicio",
  "melhous.message.end": "Fin",
  "melhous.message.active": "Activo",
  "melhous.message.info": "Información",
  "melhous.message.promo": "Promoción",
  "melhous.message.alert": "Aviso",
  "melhous.request_type": "Tipos de Solicitud",
  "melhous.request_type.name": "Nombre",
  "melhous.request_type.scope": "Dónde",
  "melhous.request_type.active": "Activo",
  "melhous.request_type.sequence": "Secuencia",
  "melhous.request_type.table": "Mesa",
  "melhous.request_type.room": "Habitación",
  "melhous.request_type.both": "Mesa y Habitación",
  "melhous.request": "Solicitudes",
  "melhous.request.type": "Tipo",
  "melhous.request.type_name": "Solicitud",
  "melhous.request.scope": "Dónde",
  "melhous.request.shop": "Tienda",
  "melhous.request.place": "Lugar",
  "melhous.request.note": "Nota",
  "melhous.request.state": "Estado",
  "melhous.request.attended_date": "Fecha de Atención",
  "melhous.request.attend": "Atender",
  "melhous.request.pending": "Pendiente",
  "melhous.request.attended": "Atendida",
  "melhous.request.table": "Mesa",
  "melhous.request.room": "Habitación",
  "melhous.recommendation": "Recomendaciones",
  "melhous.recommendation.name": "Nombre",
  "melhous.recommendation.message": "Mensaje",
  "melhous.recommendation.trigger_category": "Cuando la Categoría",
  "melhous.recommendation.trigger_product": "Cuando el Producto",
  "melhous.recommendation.active": "Activo",
  "melhous.recommendation.sequence": "Secuencia",
  "melhous.services": "Servicios",
  "melhous.special_services.icon": "Icono",
  "melhous.dash.help": "Atiende a tus huéspedes: solicitudes, guía de estadía, mensajes y PQRS.",
  "melhous.dash.tab.home": "Inicio",
  "melhous.dash.tab.hotel": "Hotel",
  "melhous.dash.tab.engage": "Atención al huésped",
  "melhous.dash.tab.requests": "Solicitudes",
  "melhous.dash.tab.pqrs": "PQRS",
  "melhous.dash.tab.appearance": "Apariencia",
  "melhous.dash.card.pending_requests": "Solicitudes pendientes",
  "melhous.dash.card.active_messages": "Mensajes activos",
  "melhous.dash.card.guide_items": "Guía",
  "melhous.dash.card.open_pqrs": "PQRS abiertas",
  "melhous.dash.hotel_notice": "Los datos del hotel (información, horarios, servicios y galería) se modifican directamente en Tryton > Melhous > Configuración.",
  "melhous.dash.recommendation_notice": "Los productos recomendados de cada regla se eligen en Tryton.",
  "melhous.dash.qr.melhous": "QR para Melhous",
  "melhous.dash.qr.restaurant": "QR para restaurante",
  "melhous.dash.qr.hotel": "QR para hotel",
  "melhous.dash.save": "Guardar cambios",
  "melhous.dash.create": "Crear configuración",
  "melhous.dash.saved": "Guardado correctamente",
  "melhous.primary_color": "Color principal",
  "melhous.secondary_color": "Color secundario",
  "melhous.accent_color": "Color de acento",
  "melhous.text_color": "Color del texto",
  "melhous.surface_color": "Color de superficie",
  "melhous.border_color": "Color de bordes",
  "melhous.show_hotel": "Mostrar Hotel",
  "melhous.show_restaurant": "Mostrar Restaurantes",
  "melhous.show_pqrs": "Mostrar PQRS",
  "melhous.show_reservation": "Mostrar Reserva",
  "melhous.show_experiences": "Mostrar Experiencias",
  "melhous.logo_link": "Link del logo",
  "melhous.dash.colors": "Colores",
  "melhous.dash.sections": "Secciones",
  "melhous.dash.color.invalid": "Usa un color hexadecimal, ej. #1f3a5f",
  "melhous.dash.color.no_aa": "No AA",
  "melhous.dash.preview.title": "Vista previa",
  "melhous.dash.preview.text": "Así se verán las tarjetas y el texto en la app.",
  "melhous.dash.preview.button": "Botón",
};

export default es;
